import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Component({
  selector: 'app-brand-categories',
  templateUrl: './brand-categories.component.html',
  styleUrls: ['./brand-categories.component.scss']
})
export class BrandCategoriesComponent implements OnInit {
  addOrEditBrandCategory: string;
  brandCategories = [];
  title = 'modal2';
  formGroup;
  deletePopupUiData;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService
    // public toastService: ToastService
  ) {}

  ngOnInit() {
    this.getAllBrandCategories();
  }

  getAllBrandCategories() {
    this.apiService.getHeaders(this.apiConfig.configGetBrandCategory)
      .subscribe((res: any) => {
        this.brandCategories = res.body.data
        console.log(this.brandCategories);
      }, err => {
        console.log(err);
      })
  }

  addBrandCategory(targetModal) {
    this.addOrEditBrandCategory = 'add'

    this.formGroup = this.fb.group({
      brand_category_name: new FormControl('', [Validators.required]),
      short_name: new FormControl('', [Validators.required]),
      status: 1
    });

    this.showBrandCategoryModal(targetModal);
  }

  get f (){
    return this.formGroup.controls
  }

  editBrandCategory(targetModal, bcInfo){
    this.addOrEditBrandCategory = 'edit'
    this.formGroup = this.fb.group({
      id: bcInfo.id,
      brand_category_name: new FormControl(bcInfo.brand_category_name, [Validators.required]),
      short_name: new FormControl(bcInfo.short_name, [Validators.required]),
      status: 1
    });

    this.showBrandCategoryModal(targetModal);
  }

  deleteBrandCategory(targetModal, bcInfo){
    this.addOrEditBrandCategory = 'delete'
    this.deletePopupUiData = bcInfo.brand_category_name;

    this.formGroup = this.fb.group({
      id: bcInfo.id,
      status: 0
    });

    this.showBrandCategoryModal(targetModal);
  }

  showBrandCategoryModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  
  submitted = false;
  onSubmitBrandCategory(formData) {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return
    }

    let apiUrl;    
    if(this.addOrEditBrandCategory == 'add'){
      apiUrl = this.apiConfig.configAddBrandCategory

      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        this.toast.Success(res.data.message);
        console.log(res);
        this.brandCategoryActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })      

    } else if(this.addOrEditBrandCategory == 'edit'){
      apiUrl = this.apiConfig.configUpdateBrandCategory + '?id=' + formData.id;
      
    } else if(this.addOrEditBrandCategory == 'delete'){
      apiUrl = this.apiConfig.configUpdateBrandCategory + '?id=' + formData.id;
      
    }

    console.log('API:', apiUrl, 'FD:', formData);
    //update and delete will only work with PUT
    //make status 0 for delete
    this.apiService.put(apiUrl, formData)
    .subscribe((res:any)=>{
      this.toast.Success(res.data.message);
      console.log(res);
      this.brandCategoryActionSuccess(formData);
    },err=>{
      console.log('err', err);
    })

  }

  brandCategoryActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllBrandCategories();
  }
}
